import 'apps/application';

import 'pages/community';
import 'pages/join-us';

import 'styles/application';

import { supportedFlagCountryCodes } from 'common/country_names';
supportedFlagCountryCodes.forEach(countryCode => {
  import(/* webpackMode: "eager" */ `../images/icons/flags/${countryCode}.svg`);
});

import 'images/icons_v2/check.svg';
import 'images/icons_v2/close.svg';
import 'images/icons_v2/chevron-left.svg';
import 'images/icons_v2/chevron-right.svg';
import 'images/icons_v2/menu.svg';

import 'images/icons/icon-play.svg';
import 'images/icons/icon-x.svg';
import 'images/icons/icon-video-player-play.svg';
import 'images/icons/button-arrow.svg';

import 'images/products/all-flavors.png';
import 'images/products/4-flavors.png';
import 'images/products/devices/juul-device-top-half.png';

import 'images/products/autoship-pods.png';

import 'images/products/subscription-view.png';
import 'images/products/subscription-calendar.png';

import 'images/social/home.jpg';
import 'images/social/default.jpg';
import 'images/social/auto-ship.jpg';
import 'images/social/logo.png';

import 'images/support/support-page-banner.jpg';

import 'apps/application/reactRails';
